import { toAbsoluteUrl } from 'utils/assets';

const EmptyTab = () => (
  <div className="mx-5">
    {/*begin::Container*/}
    <div className="text-center pt-10 mb-20">
      {/*begin::Title*/}
      <h2 className="fs-2 fw-bolder mb-7">Empty</h2>
      {/*end::Title*/}
    </div>
    {/*end::Container*/}

    {/*begin::Illustration*/}
    <div className="text-center px-4">
      <img src={toAbsoluteUrl('/media/illustrations/sigma-1/21.png')} alt="" className="mw-100 mh-300px" />
    </div>
    {/*end::Illustration*/}
  </div>
);

export { EmptyTab };
